import { DBSection } from "@db-ux/react-core-components";
import React from "react";
import type { ComponentProps } from "react";

type REDSectionProps = ComponentProps<typeof DBSection>;

const REDSection: React.FC<REDSectionProps> = (props) => {
    return <DBSection {...props}>{props.children}</DBSection>;
};

export default REDSection;